import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    state: {
        email: null,
        password: null,

        hash: null,
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
    },
    actions: {
        login({state}, payload) {
            return axios.post('/api-auth/login', state);
        },
        forget({state: {email}}, payload) {
            return axios.post('/api-auth/forget/notify', {email});
        },
        isTokenValid({state: {hash}}, payload) {
            return axios.get('/api-auth/forget/is-valid', {params: {hash}});
        },
        changePassword({state}, payload) {
            return axios.post('/api-auth/forget/save', {
                hash: state.hash,
                old_password: state.oldPassword,
                password: state.newPassword,
                password_confirmation: state.confirmPassword
            })
        }
    },
    mutations: {
        setPassword(state, data) {
            state.password = data;
        },
        setOldPassword(state, data) {
            state.oldPassword = data;
        },
        setNewPassword(state, data) {
            state.newPassword = data;
        },
        setConfirmPassword(state, data) {
            state.confirmPassword = data;
        },
        setEmail(state, data) {
            state.email = data;
        },
        setHash(state, data) {
            state.hash = data;
        }
    },
    strict: debug,
});
